<template>
  <div class="home flex-box flex-column align-center">
    <v-header />
    <section class="section">
      <router-view />
    </section>
    <v-footer />
  </div>
</template>

<script>
// @ is an alias to /src
import vHeader from "@/components/header.vue";
import vFooter from "@/components/footer.vue";
// import DraggAble from '@/components/Draggable.vue'
export default {
  name: "Home",
  data() {
    return {
      list: []
    };
  },
  components: {
    'v-header': vHeader,
    'v-footer': vFooter,
    // DraggAble
  },
  created() {
    const token = window.localStorage.getItem('token')||''
    const user = window.localStorage.getItem('webOIUser')
    if (token) {
      this.$store.dispatch('setUserInfo', {
        token: token,
        username: user
      })
    }
    
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.home {
  min-width: 1280px;
  .section {
    min-height: calc(100vh - 87px - 315px);
    width: 100%;
    display: flex;
    justify-content: center;
    background: #EFEFEF;
  }
}
</style>
